/* Ch Suggest*/
import { SuggestItemData } from "@genexus/chameleon-controls-library/dist/types/deprecated-components/suggest/suggest-list-item/ch-suggest-list-item";
import { SuggestListData } from "@genexus/chameleon-controls-library/dist/types/deprecated-components/suggest/suggest-list/ch-suggest-list";
import { SuggestData } from "@genexus/chameleon-controls-library/dist/types/deprecated-components/suggest/ch-suggest";

/* References Types*/

/**
 * @description This function converts string[] to SuggestItemData[]
 */
export const convertSuggestedApplicationsToSuggestItems = (
  suggestedApplications: string[]
): SuggestData => {
  const suggestData: SuggestData = {
    suggestItems: null,
    suggestLists: []
  };
  if (suggestedApplications.length) {
    const suggestList: SuggestListData = {
      label: "Applications",
      items: []
    };
    suggestedApplications.forEach((suggestedApplication: string) => {
      const suggestItem: SuggestItemData = {
        value: suggestedApplication,
        description: null,
        icon: null
      };
      suggestList.items.push(suggestItem);
    });
    suggestData.suggestLists.push(suggestList);
  }
  return suggestData;
};
